module.exports = __webpack_public_path__ + "static/team_bg-b73083749914c43c2188a67990820b08.png";